/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: false // set to false to use static SVG
};

const greeting = {
  username: "Akash Mane",
  title: "Hi all, I'm Akash Mane",
  subTitle: emoji(
    "passionate to bocome a  Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Akashmane21",
  linkedin: "https://www.instagram.com/akash_mane21/",
  gmail: "akash21mane21@gmail.com",
  instagram: "https://www.instagram.com/akash_mane21/",
  facebook: "https://www.facebook.com/akash.mane.777363/",
  Youtube:"https://www.youtube.com/channel/UCCm6KhVF_J6GmkylESxVrqQ",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [ 
    emoji(
    "⚡ Develop Responsive web App and mobile applications 📲 "
  ),
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and MERN Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Netlify"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
   
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "Mongo DB",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "React Native",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Google Cloud",
      fontAwesomeClassname: "fab fa-google"
    },
    {
      skillName: "github",
      fontAwesomeClassname: "fab fa-github"
    }

  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Mahatma Phule Vidyalaya ,Ahmedpur  Dist. Latur ",
      logo: "https://i.ytimg.com/vi/g1OyTXkXnAQ/maxresdefault.jpg",
      subHeader: "From 5th to 10th Standard",
      duration: "June 2011 - March 2016",
      // desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "I got 91% in the 10th Standard",
        "SSC Board of Maharastra"
      ]
    },
    {
      schoolName: "Puranmal Lahoti Government Polytechnic , Latur ",
      logo: "https://i.ytimg.com/vi/uj-Rvh8V5XQ/maxresdefault.jpg",
      subHeader: "Diploma in Computer Science",
      duration: "June 2016 - March 2019",
      desc: "I Got 85% in The Last Year Of Diploma.",
      descBullets: ["Me & My Team Develope a Final Year Project 'Online Examination System' ",
    "Organised  Techno-Spark 2K19 Event"]
    },
    {
      schoolName: "JSPM'S Rajharshi Shahu College of Engineering Tathwade , Pune",
      logo: "https://timesofindia.indiatimes.com/thumb/msid-70529616,imgsize-173653,width-400,resizemode-4/70529616.jpg",
      subHeader: "Persuing the Final Year in Information Technology",
      duration: "June 2019 - ---",
      desc: "",
      descBullets: [""]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "Some of My Big Projects That are Developed in React JS with the help of API ✨ ",
  projects: [
    {
      image: "https://images.unsplash.com/photo-1584931423339-7a8d498ca23d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80",
      projectName: "Covid-19 Tracker",
      projectDesc: "Track daily Live Updates of Covid-19 in all over the World",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://covid19-live-updates.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: "https://firebasestorage.googleapis.com/v0/b/reactcrud-7b0fc.appspot.com/o/Image%2FNews.png?alt=media&token=606a3d3c-0216-4141-b085-e7edd20198d8",
      projectName: "News Wave's",
      projectDesc: "Responsive Website of Daily News ",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://news-waves.netlify.app/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+918482930422",
  email_address: "akash21mane21@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};








const MyProjects = {
  display: true, // Set false to hide this section, defaults to true
  projects: [
    {
     Title : "Covid-19 case tracker",
     Tech : "React JS , API",
     img : "https://firebasestorage.googleapis.com/v0/b/reactcrud-7b0fc.appspot.com/o/Image%2Fcovid.png?alt=media&token=6a241b3e-53cd-408f-a1cc-4afa15115ea4",
     des:"Worldwide  , State-wise & India Covid-19 Live Case Tracker",
     Link:"https://covid19-live-updates.netlify.app/"

    },
    {
      Title : "News wave's",
      Tech :"React JS , Google News API ",
      img:"https://firebasestorage.googleapis.com/v0/b/reactcrud-7b0fc.appspot.com/o/Image%2Fnews.png?alt=media&token=ab0b21ad-2fc5-4ce4-bc55-edeaede00d48 ",
      des : "Worldwide / India's Top Headlines with Custom Search news site ",
      Link:"https://news-waves.netlify.app/"
     
    },
    {
      Title:"Space-Zone 🚀",
      Tech :"React JS , NASA API",
      img:"https://firebasestorage.googleapis.com/v0/b/reactcrud-7b0fc.appspot.com/o/Image%2Fspacex.png?alt=media&token=d12816f5-9b30-468c-9244-91c97ca42cfa",
      des:"Website created by using nasa api contains Astronomy Picture of the Day , Earth live Sattelite images , All Technologis with photo Gallary",
      Link :"https://space-zone.netlify.app/"
      
    },
    {
      Title:"Datapal ",
      Tech : "React Native , Firebase",
      img:"https://firebasestorage.googleapis.com/v0/b/reactcrud-7b0fc.appspot.com/o/Image%2Fdatapal.png?alt=media&token=d024035a-8cd0-4e86-9476-e9f92bd1e93a",
      des:"Notes , Tasks , Liks & Passwords saving Android Applications",
      Link :"https://datapal-app.netlify.app/"
    },
    {
      Title:"Cineture ",
      Tech:"React Native , Firebase",
      img:"https://firebasestorage.googleapis.com/v0/b/reactcrud-7b0fc.appspot.com/o/Image%2Fcineture.png?alt=media&token=c4d9cdf3-2a69-4e2c-abe8-c191ed32902a",
      des:"Online Movie Streming & Downloading Android Application",
      Link:"https://cineture.netlify.app/"
    },
    {
      Title:"Netflix - Clone",
      Tech :"React JS , API",
      img:"https://phpscriptsmall.com/wp-content/uploads/2017/10/netflix.jpg",
      des:"Website of Netflix",
      Link:"/"
    },
    {
     Title : "Quetes" ,
     Tech : "React JS , JavaScript",
     img:"https://firebasestorage.googleapis.com/v0/b/reactcrud-7b0fc.appspot.com/o/Image%2Fquoete.png?alt=media&token=c0a95adc-4842-4b95-a048-e868ae57884b",
     des:"Random Quoetes Generator of Famous Author",
     Link:"/"
    },
    {
      Title:"Notepad",
      Tech:"Python Tkinter",
      img:"https://akashmane21.github.io/Akash/Src/Imgs/project//notpad.PNG",
      des:"Notepad Clone",
      Link:"/"
    },
    {
      Title:"calsi",
      Tech : "Python Tkinter",
      img:"https://akashmane21.github.io/Akash/Src/Imgs/project/cal.PNG",
      des:"Advanced Calculator",
      Link:"/"
    },
    {
      Title:"ShareMe Web-App",
      Tech:"React JS , Firebase",
      img:"https://firebasestorage.googleapis.com/v0/b/reactcrud-7b0fc.appspot.com/o/Image%2FShareMe.png?alt=media&token=4f10b113-0927-4e03-9a1f-22d36daae929",
      des:"Web App for Sharing Links & Images from Mobile To Laptop ",
      Link:"/"
    },
    {
      Title:"Amazon - UI",
      Tech:"React JS , UI/UX",
      img:"https://cdn.vox-cdn.com/thumbor/46aXsGGkRgC4zT9zL5_E5s4FGEU=/0x0:1010x673/1200x800/filters:focal(0x0:1010x673)/cdn.vox-cdn.com/uploads/chorus_image/image/45176182/Screen_Shot_2015-01-07_at_11.05.22_PM.0.0.png",
      des:"Amazon - UI Clone ",
      Link:"/"
    },
     {
      Title:"Whatsapp - UI",
      Tech:"React JS , UI/UX",
      img:"https://firebasestorage.googleapis.com/v0/b/reactcrud-7b0fc.appspot.com/o/Image%2Fwhatsapp.png?alt=media&token=55e63fc0-e7f6-42be-ba9e-33248fdee399",
      des:"Whatsapp - UI Clone ",
      Link:"/"
    },
    
  ]
};



export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  MyProjects
};



